var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-main',[_c('div',{staticClass:"home"},[_c('div',{staticClass:"subheader"},[_c('div',{staticClass:"subheader-main"},[_c('div',{staticClass:"subheader-left"},[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('labels.statistics-combo'))+" ")]),_c('span',{staticClass:"separator-line"}),_c('div',{staticClass:"breadcrumbs"},[_c('router-link',{staticClass:"breadcrumbs-link",attrs:{"to":"/offices"}},[_vm._v(" "+_vm._s(_vm.$t('labels.home')))]),_c('span',{staticClass:"separator-dot"}),_c('router-link',{staticClass:"breadcrumbs-link",attrs:{"to":"/offices/statistics"}},[_vm._v(" "+_vm._s(_vm.$t('labels.statistics-combo')))])],1)]),_c('div',{staticClass:"subheader-right"},[_c('v-guard',{attrs:{"permissions":['offices-statistics-export']}},[(!_vm.isDownloading)?_c('b-dropdown',{attrs:{"id":"dropdown-1"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('i',{staticClass:"fas fa-download"}),_vm._v(" "+_vm._s(_vm.$t('labels.export')))]},proxy:true}],null,false,1426842483)},[_c('b-dropdown-group',{attrs:{"id":"dropdown-group-1","header":"Format"}},[_c('b-dropdown-item-button',{on:{"click":function($event){return _vm.exportResultsEstimate('tickets', 'excel')}}},[_vm._v("Excel ")])],1)],1):_vm._e(),(_vm.isDownloading)?_c('button',{staticClass:"btn btn-success"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"}),_vm._v(" "+_vm._s(_vm.$t('labels.is-downloading'))+" ")]):_vm._e()],1)],1)])]),_c('reactive-base',{attrs:{"app":"ticket_index,witness_person","credentials":_vm.user.user.es_username + ':' + _vm.user.user.es_password,"url":_vm.elasticUrl}},[(_vm.exportEstimate)?_c('export-tickets',{attrs:{"exportEstimate":_vm.exportEstimate,"title":"Export av statistik AD"},on:{"beginTicketExport":_vm.exportResults,"closed":_vm.closeExportTickets}}):_vm._e(),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header statistics-filter"},[_c('div',{staticClass:"widget-header-label"},[_c('h3',[_vm._v(_vm._s(_vm.$t('labels.selected-filters')))])]),_c('div',{staticClass:"widget-header-toolbar"},[_c('div',{staticClass:"actions"},[_c('SelectedFilters',{staticClass:"bb-1 curent-filters pl-4 m-0",attrs:{"clearAllLabel":this.$t('labels.clear')}})],1)])])])]),_c('v-guard',{attrs:{"permissions":['court-page-statistics-use-filter']}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"widget"},[_c('div',{staticClass:"widget-header statistics-filter"},[_c('multi-list',{attrs:{"componentId":"yearFilter","filterLabel":this.$t('labels.year'),"title":this.$t('labels.year'),"dataField":"year.raw","className":"horizontal-filter","sortBy":"asc","showSearch":false,"URLParams":true,"react":{ and: _vm.getOtherFilterIds('yearFilter') },"transformData":_vm.customYears},on:{"valueChange":_vm.setSelectedYears},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
return [_c('div',[_vm._v(_vm._s(label))])]}}])}),_c('multi-list',{attrs:{"componentId":"quarterFilter","filterLabel":this.$t('labels.quarter'),"title":this.$t('labels.quarter'),"dataField":"quarter.raw","className":"horizontal-filter","sortBy":"asc","showSearch":false,"URLParams":true,"react":{ and: _vm.getOtherFilterIds('quarterFilter') }},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
return [_c('div',[_vm._v(" "+_vm._s(label)+" ")])]}}])}),_c('multi-list',{attrs:{"componentId":"monthFilter","filterLabel":this.$t('labels.month'),"title":this.$t('labels.month'),"dataField":"month.raw","className":"horizontal-filter","sortBy":"asc","size":12,"showSearch":false,"URLParams":true,"transformData":_vm.sortMonthByLabel,"react":{ and: _vm.getOtherFilterIds('monthFilter') }},scopedSlots:_vm._u([{key:"renderItem",fn:function(ref){
var label = ref.label;
var count = ref.count;
return [_c('div',[_vm._v(" "+_vm._s(_vm.renameMonthsLabel(label))+" ")])]}}])})],1)])]),_c('div',{staticClass:"col-lg-12 col-xl-3 order-lg-1 order-xl-1"},[_c('div',{staticClass:"widget widget-facets statistics-vertical"},[_c('div',{staticClass:"widget-header mb-3"},[_c('div',{staticClass:"widget-header-label"},[_c('h3',[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"fas fa-circle-notch fa-spin"}),_vm._v(_vm._s(_vm.$t('labels.filtration')))])]),_c('div',{staticClass:"widget-header-toolbar"},[_c('div',{staticClass:"actions"})])]),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"genderFilter","filterLabel":this.$t('labels.gender'),"title":this.$t('labels.gender'),"dataField":'gender.raw',"react":{ and: _vm.getOtherFilterIds('genderFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"agesFilter","filterLabel":this.$t('labels.age-group'),"title":this.$t('labels.age-group'),"dataField":'age.raw',"transformData":_vm.customSortAge,"react":{ and: _vm.getOtherFilterIds('agesFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"categoryFilter","size":300,"title":"Kategori","filterLabel":"Kategori","dataField":"ad_category.keyword","react":{ and: _vm.getOtherFilterIds('categoryFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"crimesFilter","size":300,"title":this.$t('labels.crime'),"filterLabel":this.$t('labels.crime'),"dataField":"ad_crime.keyword","react":{ and: _vm.getOtherFilterIds('crimesFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.special-circumstances'),"componentId":"specialCircumstanceFilter","filterLabel":this.$t('labels.special-circumstances'),"nestedField":"crime_relation","dataField":'crime_relation.label.raw',"react":{ and: _vm.getOtherFilterIds('specialCircumstanceFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":this.$t('labels.special-events'),"componentId":"specialEventFilter","filterLabel":this.$t('labels.special-events'),"dataField":'special_event.raw',"react":{ and: _vm.getOtherFilterIds('specialEventFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":100,"componentId":"officeFilter","title":this.$t('labels.victim-support-centre'),"filterLabel":this.$t('labels.victim-support-centre'),"dataField":"office.raw","react":{ and: _vm.getOtherFilterIds('officeFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","title":"Stödinsats","componentId":"testimonySupportFilter","filterLabel":"Stödinsats","nestedField":"testimony_support","dataField":"testimony_support.label.raw","react":{ and: _vm.getOtherFilterIds('testimonySupportFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","size":100,"componentId":"courtFilter","filterLabel":"Domstol","title":"Domstol","dataField":"court.raw","react":{ and: _vm.getOtherFilterIds('courtFilter') }}})],1),_c('div',{staticClass:"widget-body p-0"},[_c('multi-dropdown-list',{attrs:{"className":"filter-vertical","URLParams":true,"showSearch":true,"placeholder":this.$t('labels.select'),"sortBy":"asc","componentId":"typeOfTicketFilter","size":300,"title":"Statistiktabell","filterLabel":"Statistiktabell","dataField":"ad_type_of_ticket.keyword","react":{ and: _vm.getOtherFilterIds('typeOfTicketFilter') }}})],1)])])]),_c('div',{staticClass:"col-lg-12 col-xl-9 order-lg-1 order-xl-1"},[_c('reactive-component',{attrs:{"componentId":"myColorPicker","URLParams":true,"react":{ and: _vm.getOtherFilterIds('') },"defaultQuery":function () { return ({
                        query: {
                            bool: {
                                must: [{
                                    range: {
                                        'year.raw': {
                                            gte: 2022
                                        },
                                    }
                                }],
                            },
                            
                        },
                        runtime_mappings: {
                            'date.month_of_years': {
                            type: 'long',
                            script: 'emit(doc[\'created_at\'].value.getMonthValue())'
                            }
                        },
                        aggs: {
                            year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                        _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                            },
                            crimes: {
                            terms: {
                                field: 'ad_crime.keyword',
                                order: {
                                _key: 'asc'
                                },
                                size: 100,
                                exclude : ''
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            office: {
                            terms: {
                                field: 'office.raw',
                                order: {
                                _key: 'asc'
                                },
                                size: 100
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            testimony_security_room: {
                            terms: {
                                field: 'testimony_security_room.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            court_contact_type: {
                            terms: {
                                field: 'court_contact_type.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            gender: {
                            terms: {
                                field: 'gender.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            age: {
                            terms: {
                                field: 'age.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            testimony_applicant: {
                            terms: {
                                field: 'testimony_applicant.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            month: {
                            terms: {
                                field: 'date.month_of_years',
                                order: {
                                _key: 'asc'
                                },
                                size: 100
                            },
                            aggs: {
                                year: {
                                terms: {
                                    script: 'if (doc[\'created_at\'].size() != 0) doc[\'created_at\'].value.getYear()',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            quarter: {
                            terms: {
                                field: 'quarter.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            user: {
                            terms: {
                                field: 'user.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            testimony_support: {
                            nested: {
                                path: 'testimony_support'
                            },
                            aggs: {
                                relation: {
                                terms: {
                                    field: 'testimony_support.label.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    size: 100
                                },
                                aggs: {
                                    reverted: {
                                    reverse_nested: {},
                                    aggs: {
                                        year: {
                                        terms: {
                                            field: 'year.raw',
                                            order: {
                                            _key: 'asc'
                                            },
                                            min_doc_count: 1,
                                            size: 100
                                        }
                                        }
                                    }
                                    }
                                }
                                }
                            }
                            },
                            persons: {
                            nested: {
                                path: 'persons'
                            },
                                aggs: {
                                    reverted: {
                                    reverse_nested: {},
                                    aggs: {
                                        year: {
                                        terms: {
                                            field: 'year.raw',
                                            order: {
                                            _key: 'asc'
                                            },
                                            min_doc_count: 1,
                                            size: 100
                                        }
                                        }
                                    }
                                }
                            }
                            },
                            external_case: {
                            terms: {
                                field: 'external_case.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            court: {
                            terms: {
                                field: 'court.raw',
                                order: {
                                    _key: 'asc'
                                },
                                size: 100,
                                exclude : ['']
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            testimony_other_type: {
                            terms: {
                                field: 'testimony_other_type.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 1000000
                                }
                                }
                            }
                            },
                            testimony_type: {
                            terms: {
                                field: 'testimony_type.raw',
                                order: {
                                _key: 'asc'
                                }
                            },
                            aggs: {
                                year: {
                                terms: {
                                    field: 'year.raw',
                                    order: {
                                    _key: 'asc'
                                    },
                                    min_doc_count: 1,
                                    size: 100
                                }
                                }
                            }
                            },
                            crime_relation: {
                                nested: {
                                    path: 'crime_relation',
                                },
                                aggs: {
                                    relation: {
                                        terms: {
                                            field: 'crime_relation.label.raw',
                                            order: {
                                                _key: 'asc'
                                            },
                                            size: 100,

                                        },
                                        aggs: {
                                            reverted: {
                                                reverse_nested: {},
                                                aggs: {
                                                    year: {
                                                        terms: {
                                                            field: 'year.raw',
                                                            order: {
                                                                _key: 'asc'
                                                            },
                                                            min_doc_count: 1,
                                                            size: 100,
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                    },
                                },
                            },
                            special_event: {
                                terms: {
                                    field:  this$1.$field('special_event')+'.raw',
                                    order: {
                                        _key: 'asc'
                                    },
                                },
                                aggs: {
                                    year: {
                                        terms: {
                                            field: 'year.raw',
                                            order: {
                                                _key: 'asc'
                                            },
                                            min_doc_count: 1,
                                            size: 100,
                                        },
                                    },
                                },
                            },
                            category: {
                                terms: {
                                    field:  'ad_category.keyword',
                                    order: {
                                        _key: 'asc'
                                    },
                                },
                                aggs: {
                                    year: {
                                        terms: {
                                            field: 'year.raw',
                                            order: {
                                                _key: 'asc'
                                            },
                                            min_doc_count: 1,
                                            size: 100,
                                        },
                                    },
                                },
                            },
                            type_of_ticket: {
                                terms: {
                                    field:  'ad_type_of_ticket.keyword',
                                    order: {
                                        _key: 'asc'
                                    },
                                },
                                aggs: {
                                    year: {
                                        terms: {
                                            field: 'year.raw',
                                            order: {
                                                _key: 'asc'
                                            },
                                            min_doc_count: 1,
                                            size: 100,
                                        },
                                    },
                                },
                            },
                            testimony_support: {
                                nested: {
                                    path: 'testimony_support',
                                },
                                aggs: {
                                    relation: {
                                        terms: {
                                            field: 'testimony_support.label.raw',
                                            order: {
                                                _key: 'asc'
                                            },
                                            size: 100,

                                        },
                                        aggs: {
                                            reverted: {
                                                reverse_nested: {},
                                                aggs: {
                                                    year: {
                                                        terms: {
                                                            field: 'year.raw',
                                                            order: {
                                                                _key: 'asc'
                                                            },
                                                            min_doc_count: 1,
                                                            size: 100,
                                                        }
                                                    }
                                                }
                                            }
                                        },
                                    },
                                },
                            },
                        }
                    }); }},on:{"queryChange":_vm.getQueryChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                    var aggregations = ref.aggregations;
                    var hits = ref.hits;
                    var setQuery = ref.setQuery;
return _c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('statistic-widget-total',{attrs:{"yearsSelected":_vm.yearsSelected,"data":aggregations.year.buckets,"title":_vm.$t('labels.total')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.quarter.buckets,"infoBox":'',"title":_vm.$t('labels.quarter')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.month.buckets,"infoBox":'',"title":_vm.$t('labels.month')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.gender.buckets,"infoBox":'',"title":_vm.$t('labels.gender')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":_vm.customSortAge(aggregations.age.buckets),"infoBox":'',"title":_vm.$t('labels.age-group')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.category.buckets,"infoBox":'',"title":"Kategori"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.crimes.buckets,"infoBox":'',"title":_vm.$t('labels.crime')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.crime_relation.relation.buckets,"title":_vm.$t('labels.special-circumstances')}},[_vm._v(">")])],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.special_event.buckets,"title":_vm.$t('labels.special-events')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.office.buckets,"infoBox":'',"title":_vm.$t('labels.victim-support-centre')}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":_vm.sortTestimonySupport(aggregations.testimony_support.relation.buckets),"title":"Stödinsats"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.court.buckets,"infoBox":'',"title":"Domstol"}})],1),_c('div',{staticClass:"col-12"},[_c('statistic-widget',{attrs:{"yearsSelected":_vm.yearsSelected,"yearsAggs":aggregations.year.buckets,"data":aggregations.type_of_ticket.buckets,"infoBox":'',"title":"Statistiktabell"}})],1)])])}}])})],1)],1)],1),_c('ScrollTopArrow')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }